import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
interface AccordionItemProps {
  question: string;
  answer: string;
}
export function Accordion({
  items
}: {
  items: AccordionItemProps[];
}) {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <div className="space-y-4" data-id="element-163">
      {items.map((item, index) => {
      const isOpen = openIndex === index;
      return <div key={index} className="bg-dark-lighter border border-white/10 rounded-lg overflow-hidden" data-id="element-164">
            <button onClick={() => setOpenIndex(isOpen ? null : index)} className="w-full flex items-center justify-between p-6 text-left focus:outline-none" data-id="element-165">
              <span className="text-xl font-bold text-white pr-4" data-id="element-166">
                {item.question}
              </span>
              <motion.div animate={{
            rotate: isOpen ? 180 : 0
          }} transition={{
            duration: 0.2
          }} data-id="element-167">
                <ChevronDown className="w-6 h-6 text-amber shrink-0" data-id="element-168" />
              </motion.div>
            </button>
            <AnimatePresence data-id="element-169">
              {isOpen && <motion.div initial={{
            height: 0,
            opacity: 0
          }} animate={{
            height: 'auto',
            opacity: 1
          }} exit={{
            height: 0,
            opacity: 0
          }} transition={{
            duration: 0.3
          }} data-id="element-170">
                  <div className="p-6 pt-0 text-lg text-offwhite/80 border-t border-white/5" data-id="element-171">
                    {item.answer}
                  </div>
                </motion.div>}
            </AnimatePresence>
          </div>;
    })}
    </div>;
}